// src/features/editor/components/studio/screenDeleteConfirm.ts
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Общий текст диалога удаления экрана — один источник для миниатюры
 * (`BlockThumbnail`) и шапки панели (`BlockPanelHeader`), п.25 бэк-лога.
 * Дословный дубль в двух местах уже расходился (ревью Task 2, Important-1):
 * шапка называла `order + 1` (с дырами после удаления — `deleteBlock` не
 * перенумеровывает соседей), миниатюра — позиционный `index + 1`. Общая
 * функция, принимающая ГОТОВЫЙ индекс, делает такое расхождение структурно
 * невозможным — обе точки обязаны прислать один и тот же позиционный ранг.
 */
export const screenDeleteConfirm = (
  index: number | null,
  label: string,
): { title: string; description: string } => {
  const m = messagesNow(messages)
  return {
    // `null` — позиция НЕИЗВЕСТНА (блоки урока ещё не приехали). Заголовок без
    // номера честнее подставленного `?? 0`: тот уверенно обещал «Удалить экран
    // 1?» на любом блоке, чью позицию не нашли.
    title: index === null ? m.deleteScreenUnknown : m.deleteScreen(index + 1),
    // Языки курса — поля одного блока: удаление экрана убирает его сразу во всех языках.
    description: m.deleteScreenDescription(label),
  }
}
